import React from "react";
import { Box, Typography, Tabs, Tab, Alert } from "@mui/material";
import { RISK_CHART_HEIGHT } from "../utils/constants";
import RawRecordsTable from "./RawRecordsTable";
import ReportingCategoryDateChart from "./ReportingCategoryDateChart";
import RiskBarChart from "./RiskBarChart";
import EstimatedTimeChart, {
  EstimatedTimeDataTable,
} from "./EstimatedTimeChart";
import MissionChart from "./Missionchart";
import GuestChart from "./Guestchart";
import TPerformanceChart from "./TPerformanceChart";
import IncidentChartOptions from "./IncidentChartOptions";
import MissionChartOptions from "./MissionChartOptions";

const RiskAnalysisTabContent = ({
  activeTabKey,
  tab,
  setTab,
  tabDefs,
  lang,
  organizationId,
  isPrototypeGrouped,
  incidentChartGroups,
  reportingPrototypeGroups,
  prototypeChartGroups,
  incidentRef,
  tPerformanceRef,
  missionRef,
  guestRef,
  estimatedRef,
  assignNodeRef,
  incidentChartRefs,
  tPerformanceChartRefs,
  showRealIncident,
  showIncidentYellow,
  showIncidentRed,
  includeTrainingData,
  includeReadData,
  showMinInjuries,
  setShowMinInjuries,
  setShowRealIncident,
  showTraining,
  setShowTraining,
  showRead,
  setShowRead,
  showNull,
  setShowNull,
  setShowIncidentYellow,
  setShowIncidentRed,
  isGentofteLife,
  t,
  riskRecordsLoading,
  actionCardsLoading,
  missionGuestLoading,
  missionGuestError,
  estimatedLoading,
  estimatedError,
  missionFiltered,
  guestFiltered,
  estimatedFiltered,
  mDateFrom,
  mDateTo,
  mTimeRange,
  mSetNumbers,
  mShowGreen,
  mShowYellow,
  mShowRed,
  setMDateFrom,
  setMDateTo,
  setMTimeRange,
  setMSetNumbers,
  setMShowGreen,
  setMShowYellow,
  setMShowRed,
  gDateFrom,
  gDateTo,
  gTimeRange,
  gSetNumbers,
  setGDateFrom,
  setGDateTo,
  setGTimeRange,
  setGSetNumbers,
  eDateFrom,
  eDateTo,
  eTimeRange,
  eSetNumbers,
  eBeach,
  setEDateFrom,
  setEDateTo,
  setETimeRange,
  setESetNumbers,
  setEBeach,
  rDateFrom,
  rDateTo,
  rShowNearMiss,
  rShowPrevention,
  rShowDoubtAboutReporting,
  renderLoader,
  tableRef,
  riskPdfTableRecords,
  actionCards,
}) => (
  <>
    <Box className="risk-analysis-plot-card" sx={{ mt: 3 }}>
      <Typography className="risk-analysis-card-title">
        Risk Analysis Plot(s)
      </Typography>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          minHeight: 48,
          p: 0.75,
          borderRadius: 3,
          backgroundColor: "#fff5f5",
          "& .MuiTabs-indicator": { display: "none" },
          "& .MuiTab-root": {
            textTransform: "none",
            borderRadius: 2.5,
            minHeight: 40,
            color: "#8b3a3a",
            fontWeight: 600,
            transition: "all 0.2s ease",
          },
          "& .Mui-selected": {
            backgroundColor: "#fde5e5",
            color: "#a33232",
          },
        }}
      >
        {tabDefs.map((td) => (
          <Tab key={td.key} label={td.label} />
        ))}
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {activeTabKey === "faktuel" && (
          <Box className="risk-chart-with-options">
            <div ref={incidentRef} className="risk-chart-main">
              {incidentChartGroups.map((group, index) => (
                <Box
                  key={`incident-${group.key}`}
                  sx={{
                    mb: index === incidentChartGroups.length - 1 ? 0 : 4,
                  }}
                >
                  {isPrototypeGrouped && group.title ? (
                    <Typography
                      sx={{ mb: 2, fontWeight: 700, color: "#8b3a3a" }}
                    >
                      {group.title}
                    </Typography>
                  ) : null}
                  <div
                    ref={(node) =>
                      assignNodeRef(incidentChartRefs, group.key, node)
                    }
                    style={{ width: "100%" }}
                  >
                    <RiskBarChart
                      defaultRecords={group.defaultRecords}
                      reportingCategoryRecords={group.reportingCategoryRecords}
                      trainingRecords={group.trainingRecords}
                      readRecords={group.readRecords}
                      organizationId={organizationId}
                      showRealIncident={showRealIncident}
                      showIncidentYellow={showIncidentYellow}
                      showIncidentRed={showIncidentRed}
                      showMinInjuriesBar
                      showTraining={includeTrainingData}
                      showRead={includeReadData}
                      actionCards={group.actionCards}
                      lang={lang}
                      height={RISK_CHART_HEIGHT}
                      defaultBarColor={
                        group.key === "C01" || group.prototype_set_id === "C01"
                          ? "#FF4D00"
                          : undefined
                      }
                    />
                  </div>
                </Box>
              ))}
            </div>
            <IncidentChartOptions
              t={t}
              isGentofteLife={isGentofteLife}
              showMinInjuries={showMinInjuries}
              setShowMinInjuries={setShowMinInjuries}
              showRealIncident={showRealIncident}
              setShowRealIncident={setShowRealIncident}
              showTraining={showTraining}
              setShowTraining={setShowTraining}
              showRead={showRead}
              setShowRead={setShowRead}
              showNull={showNull}
              setShowNull={setShowNull}
              showIncidentYellow={showIncidentYellow}
              setShowIncidentYellow={setShowIncidentYellow}
              showIncidentRed={showIncidentRed}
              setShowIncidentRed={setShowIncidentRed}
            />
          </Box>
        )}

        {activeTabKey === "reportingCategory" &&
          (riskRecordsLoading || actionCardsLoading ? (
            renderLoader(
              lang === "dk"
                ? "Indlæser PreVent Data..."
                : "Loading PreVent Data..."
            )
          ) : (
            <div className="risk-chart-main">
              {reportingPrototypeGroups.map((group, index) => (
                <Box
                  key={`reporting-${group.key}`}
                  sx={{
                    mb: index === reportingPrototypeGroups.length - 1 ? 0 : 4,
                  }}
                >
                  {isPrototypeGrouped && group.title ? (
                    <Typography
                      sx={{ mb: 2, fontWeight: 700, color: "#8b3a3a" }}
                    >
                      {group.title}
                    </Typography>
                  ) : null}
                  <div style={{ width: "100%" }}>
                    <ReportingCategoryDateChart
                      records={group.reportingCategoryRecords}
                      dateFrom={rDateFrom}
                      dateTo={rDateTo}
                      showNearMiss={rShowNearMiss}
                      showPrevention={rShowPrevention}
                      showDoubtAboutReporting={rShowDoubtAboutReporting}
                      lang={lang}
                      height={RISK_CHART_HEIGHT}
                    />
                  </div>
                </Box>
              ))}
            </div>
          ))}

        {activeTabKey === "performance" && (
          <div ref={tPerformanceRef} className="risk-chart-main">
            {prototypeChartGroups.map((group, index) => (
              <Box
                key={`performance-${group.key}`}
                sx={{
                  mb: index === prototypeChartGroups.length - 1 ? 0 : 4,
                }}
              >
                {isPrototypeGrouped && group.performanceTitle ? (
                  <Typography sx={{ mb: 2, fontWeight: 700, color: "#8b3a3a" }}>
                    {group.performanceTitle}
                  </Typography>
                ) : null}
                <div
                  ref={(node) =>
                    assignNodeRef(tPerformanceChartRefs, group.key, node)
                  }
                  style={{ width: "100%" }}
                >
                  <TPerformanceChart
                    records={group.performanceRecords}
                    actionCards={group.actionCards}
                    lang={lang}
                    height={RISK_CHART_HEIGHT}
                  />
                </div>
              </Box>
            ))}
          </div>
        )}

        {activeTabKey === "mission" &&
          (missionGuestLoading ? (
            renderLoader("Loading mission & guest data...")
          ) : missionGuestError ? (
            <Alert severity="error" sx={{ mt: 2 }}>
              {String(missionGuestError)}
            </Alert>
          ) : (
            <Box className="risk-chart-with-options">
              <div ref={missionRef} className="risk-chart-main">
                <MissionChart
                  data={missionFiltered}
                  organizationId={organizationId}
                  lang={lang}
                  hideFilters
                  height={RISK_CHART_HEIGHT}
                  externalFilters={{
                    dateFrom: mDateFrom,
                    dateTo: mDateTo,
                    timeRange: mTimeRange,
                    setNumbers: mSetNumbers,
                    showGreen: mShowGreen,
                    showYellow: mShowYellow,
                    showRed: mShowRed,
                    setDateFrom: setMDateFrom,
                    setDateTo: setMDateTo,
                    setTimeRange: setMTimeRange,
                    setSetNumbers: setMSetNumbers,
                    setShowGreen: setMShowGreen,
                    setShowYellow: setMShowYellow,
                    setShowRed: setMShowRed,
                  }}
                />
              </div>
              <MissionChartOptions
                mShowGreen={mShowGreen}
                setMShowGreen={setMShowGreen}
                mShowYellow={mShowYellow}
                setMShowYellow={setMShowYellow}
                mShowRed={mShowRed}
                setMShowRed={setMShowRed}
              />
            </Box>
          ))}

        {activeTabKey === "guest" &&
          (missionGuestLoading ? (
            renderLoader("Loading mission & guest data...")
          ) : missionGuestError ? (
            <Alert severity="error" sx={{ mt: 2 }}>
              {String(missionGuestError)}
            </Alert>
          ) : (
            <div ref={guestRef} className="risk-chart-main">
              <GuestChart
                data={guestFiltered}
                organizationId={organizationId}
                lang={lang}
                hideFilters
                height={RISK_CHART_HEIGHT}
                externalFilters={{
                  dateFrom: gDateFrom,
                  dateTo: gDateTo,
                  timeRange: gTimeRange,
                  setNumbers: gSetNumbers,
                  setDateFrom: setGDateFrom,
                  setDateTo: setGDateTo,
                  setTimeRange: setGTimeRange,
                  setSetNumbers: setGSetNumbers,
                }}
              />
            </div>
          ))}

        {activeTabKey === "estimated" &&
          (estimatedLoading ? (
            renderLoader("Loading estimated time data...")
          ) : estimatedError ? (
            <Alert severity="error" sx={{ mt: 2 }}>
              {String(estimatedError)}
            </Alert>
          ) : (
            <div ref={estimatedRef} className="risk-chart-main">
              <EstimatedTimeChart
                data={estimatedFiltered}
                organizationId={organizationId}
                lang={lang}
                hideFilters
                showTable={false}
                height={RISK_CHART_HEIGHT}
                externalFilters={{
                  dateFrom: eDateFrom,
                  dateTo: eDateTo,
                  timeRange: eTimeRange,
                  setNumbers: eSetNumbers,
                  beach: eBeach,
                  setDateFrom: setEDateFrom,
                  setDateTo: setEDateTo,
                  setTimeRange: setETimeRange,
                  setSetNumbers: setESetNumbers,
                  setBeach: setEBeach,
                }}
              />
            </div>
          ))}
      </Box>
    </Box>

    {activeTabKey === "faktuel" ? (
      <Box className="risk-analysis-table-card" ref={tableRef}>
        <Typography className="risk-analysis-card-title">
          Risk Analysis Table
        </Typography>
        {riskRecordsLoading || actionCardsLoading ? (
          renderLoader(
            lang === "dk" ? "Indlæser rådata..." : "Loading raw records..."
          )
        ) : (
          <RawRecordsTable
            records={riskPdfTableRecords}
            actionCards={actionCards}
            lang={lang}
            organizationId={organizationId}
          />
        )}
      </Box>
    ) : null}

    {activeTabKey === "estimated" && !estimatedLoading && !estimatedError ? (
      <Box className="risk-analysis-table-card">
        <Typography className="risk-analysis-card-title">
          {lang === "dk" ? "Redningstidsdata" : "Rescue Time Data"}
        </Typography>
        <EstimatedTimeDataTable records={estimatedFiltered} lang={lang} />
      </Box>
    ) : null}
  </>
);

export default RiskAnalysisTabContent;
